import TweelioVideoDraggable from './tweelio-video-draggable';

export default TweelioVideoDraggable;
